import type { ReactNode } from 'react';

export const symbol_floor_lamp: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M459.5-208.63Q451-217.25 451-230v-290H228q-15.45 0-24.73-12.5Q194-545 199-559l86-279q6.11-18.75 22.13-30.38Q323.16-880 343-880h276q19.84 0 35.87 11.62Q670.89-856.75 677-838l86 279q5 14-4.27 26.5Q749.45-520 734-520H511v290q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM268-580h426l-74-240H342l-74 240Zm93 500q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h240q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q613.75-80 601-80H361Zm120-620Z"
		/>
	</svg>
);
